import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import Routes from "./Routes";
import { Toaster } from "@fluentui/react-components";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Routes />
    <Toaster toasterId="kpi-toaster" position="bottom-end" />
  </React.StrictMode>,
);

reportWebVitals();
